module.exports = __webpack_public_path__ + "img/43_68.0464dcbe.png";